import { isRequired } from 'Automations/nodeDefinitions/validation/validators'
import { allHandlesConnected } from 'Automations/nodeDefinitions/validation/nodeValidators'

export const reviewTypeRequired = isRequired({
  title: 'Missing review type',
  message: 'Review node requires a type'
})

export const approversRequired = isRequired({
  title: 'Missing approvers',
  message: 'Review node requires at least 1 approver'
})

export const handlesConnected = allHandlesConnected({
  handleTypes: ['target', 'source'],
  title: 'Disconnected node',
  message: 'All handles must be connected'
})
